import { createFileRoute } from '@tanstack/react-router';
import { ComingSoon } from '@/features/placeholder/ComingSoon.tsx';

// Placeholder until this area is ported — see docs/features/*-flock-costs.md.
export const Route = createFileRoute('/_app/flock-costs')({
  component: FlockCostsPage,
});

function FlockCostsPage() {
  return <ComingSoon slug="flock-costs" />;
}
